import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, signInAnonymously } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBZuK0hXTkmzEWZVLrf1ZQwWJ2hxxx-qXQ",
  authDomain: "data-ingestion-pipeline-461106.firebaseapp.com",
  projectId: "data-ingestion-pipeline-461106",
  storageBucket: "data-ingestion-pipeline-461106.firebasestorage.app",
  messagingSenderId: "922405893209",
  appId: "1:922405893209:web:38603a03eb18131bc32d48",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app, "data-harvest-db");
export const storage = getStorage(app);

export const auth = getAuth(app);

// 🔹 Ensure anonymous login happens once
export async function ensureAnonAuth() {
  if (!auth.currentUser) {
    await signInAnonymously(auth);
  }
}
